export default function CTASection() {
  return (
    <section className="relative py-16 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_255a23c3e92609c31ab8866ab093c98f_2767d5cb.jpg"
          alt="Happy dog walk"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#6B7A66]/80 via-[#6B7A66]/70 to-[#6B7A66]/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 text-center">
        <span className="inline-block bg-white/15 border border-white/30 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
          Limited Time Offer
        </span>
        <h2 className="text-3xl md:text-6xl font-bold text-white mb-5 md:mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          Ready for Easier<br />Dog Walks?
        </h2>
        <p className="text-white/80 text-base md:text-xl mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed">
          Join 10,000+ dog owners who've already made cleanup effortless. Get yours today starting at just $18.
        </p>

        <a
          href="#product"
          className="inline-flex items-center gap-2 bg-white hover:bg-stone-100 text-[#C4956A] font-bold text-lg px-10 py-5 rounded-full transition-colors whitespace-nowrap cursor-pointer shadow-lg"
        >
          Get Yours Now — From $18
          <i className="ri-arrow-right-line"></i>
        </a>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: 'ri-truck-line', label: 'Free Shipping $50+' },
            { icon: 'ri-refresh-line', label: '30-Day Returns' },
            { icon: 'ri-shield-check-line', label: 'Secure Checkout' },
          ].map((badge) => (
            <div key={badge.label} className="flex items-center gap-2 text-white/80 text-sm">
              <i className={`${badge.icon} text-base`}></i>
              <span>{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
